export const newCourierPickup: string = 'new'